module.exports = __webpack_public_path__ + "17f268f310b9c9529a293ac1e9468f15.png";